/**
 * Where to land after logging in or signing up.
 *
 * Normally the dashboard, but someone who arrived on an invite link came here to join
 * a specific playlist - dropping them on the dashboard instead loses the invite and
 * leaves them with nothing to click. InvitePage parks the token before sending them
 * off to authenticate, and this hands it back.
 */
export const PENDING_INVITE_KEY = "shufl:pendingInvite";

export function postAuthDestination(): string {
    const token = sessionStorage.getItem(PENDING_INVITE_KEY);
    return token ? `/invite/${token}` : "/dashboard";
}
